import { ManageChatLinkDomainsPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/chat-link-domains'].update({
        staticData: { title: { page: 'ChatLinkDomains.PageHeading' } },
        component: authGuard(ManageChatLinkDomainsPage, { canManageChatLinkDomains: true })
    });
};
